<template>
  <b-modal
    id="modal-contractor-id"
    :title="edit ? $t('edit_contact') : $t('add_contact')"
    cancel-variant="outline-secondary"
    :ok-title="$t('save')"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    centered
    no-close-on-backdrop
    @show="showModal"
    @ok="onSubmit"
  >
    <validation-observer ref="contact_agent">
      <b-form>
        <b-form-group
          :label="$t('name')"
          for="fullName"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('name')"
            rules="required"
          >
            <b-form-input
              id="fullName"
              v-model="contractor.name"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group
          :label="$t('position')"
          for="position"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('position')"
            rules="required"
          >
            <b-form-input
              id="position"
              v-model="contractor.position"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group
          :label="$t('contact.phone_number')"
          for="number"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('contact.phone_number')"
            rules="required|length:12"
          >
            <b-form-input
              id="number"
              v-model="contractor.phone_number"
              on-key-press="if(this.value.length==12) return false;"
              max="12"
              type="number"
            />
            <small class="text-danger">{{ errors[0] }}</small>
            <span
              v-if="contractor.phone_number"
              :class="contractor.phone_number.length === 12 ? 'text-dark' : 'text-danger'"
              class="float-right"
            >
              {{ contractor.phone_number.length }}
              <span class="text-dark">/12</span>
            </span>
          </validation-provider>
        </b-form-group>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@core/utils/validations/validations'
import { mapActions } from 'vuex'
import objective from '@/mixins/objective'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [objective],
  props: {
    editContactAgent: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  data() {
    return {
      required,
      contractor: {
        name: '',
        position: '',
        phone_number: null,
      },
      edit: false,
    }
  },
  methods: {
    ...mapActions('contacts', ['CREATE_AGENT', 'FETCH_ALL_CONTACTS_LIST_ID', 'UPDATE_CONTRACT_AGENT']),

    showModal() {
      this.edit = false
      if (!this.editContactAgent) {
        return
      }

      if (typeof this.editContactAgent === 'object' && this.editContactAgent !== null) {
        this.contractor = this.$_removeObjectConnection(this.editContactAgent)
        if(this.contractor.name && this.contractor.name != ''){
          this.edit = true
        }
      }
    },

    onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.$refs.contact_agent.validate()
        .then(async success => {
          if (success) {
            if (this.editContactAgent.id) {
              await this.UPDATE_CONTRACT_AGENT(this.contractor)
                .then(() => {
                  this.$_okToast()
                  this.$bvModal.hide('modal-contractor-id')
                  this.FETCH_ALL_CONTACTS_LIST_ID(this.$route.params.id)
                })
            } else {
              await this.CREATE_AGENT({
                contact: this.$route.params.id,
                ...this.contractor,
              })
                .then(() => {
                  this.$_okToast()
                  this.$bvModal.hide('modal-contractor-id')
                  this.FETCH_ALL_CONTACTS_LIST_ID(this.$route.params.id)
                })
                .catch(err => {
                  this.$_errToast(err)
                })
            }
          }
        })
    },
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
}
</script>
